import React from "react";
import News from "../../component/news/index";

export function Newss() {
  return <News />;
}
